import LazyLoad from 'vanilla-lazyload';

const TARGET_ID = 'infinite-list';

export default class InfiniteScroll {
    constructor(context) {
        this.entityId = this.getPostId(context);
        this.documentTitle = document.title;
        this.postTitle = context.getAttribute('data-title');

        // В data-collection местами прописывают "0", а где-то вообще ID коллекции
        this.isCollection = context.getAttribute('data-collection');
        this.isCollection = (this.isCollection === null || this.isCollection === "" || this.isCollection === '0')
            ? false
            : true
        ;

        this.postCategory = context.getAttribute('data-category');

        this.$targetEl = document.getElementById(TARGET_ID);
        this.loadedPosts = [
            {
                id: Number(this.entityId),
                title: document.title,
                url: window.location.href
            }
        ];
        this.ratedPosts = [];
        this.allPostsLoaded = false;
        this.postObservers = [];
        this.ratingsObservers = {};
        this.isLoading = false;

        this.visiblePosts = {
            [this.entityId]: {
                title: document.title,
                url: window.location.href
            }
        };

        const options = this.getLazyloadOptions({
            elements_selector: `.card_post[data-id="${this.entityId}"]`
        });
        const initialPostObserver = new LazyLoad(options);
        this.postObservers.push(initialPostObserver);

        const renderNextBlogPostHandler = () => {
            if (this.allPostsLoaded || this.isCollection || this.postCategory == 'noji-sertificat') {
                document.removeEventListener(
                    'renderNextBlogPost',
                    renderNextBlogPostHandler
                );
                return;
            }

            this.fetchNextPost();
        };

        document.addEventListener(
            'renderNextBlogPost',
            renderNextBlogPostHandler
        );

        document.addEventListener('updateExcludedPosts', e => {
            this.ratedPosts = e.detail;
        });
    }

    /**
     * @description Используется для динамического формирования объекта конфигурации
     * для нового инстанса LazyLoad
     */
    getLazyloadOptions(options) {
        const baseObserverOptions = {
            threshold: 0,
            callback_enter: $el => {
                if (this.loadedPosts.length > 1) {
                    const id = this.getPostId($el);
                    const post = this.loadedPosts.find(p => p.id === id);
                    this.visiblePosts[id] = {
                        title: post.title,
                        url: post.url
                    };

                    if (post.collection) {
                        this.visiblePosts[id].collection = post.collection;
                    }
                }
            },
            callback_exit: $el => {
                const id = this.getPostId($el);
                if (this.visiblePosts[id]) {
                    delete this.visiblePosts[id];
                }

                const visiblePostId = Object.keys(this.visiblePosts)[0];
                if (visiblePostId && this.visiblePosts[visiblePostId]) {
                    this.changeLocationUrl({
                        id: visiblePostId,
                        ...this.visiblePosts[visiblePostId]
                    });
                }
            },
            unobserve_completed: false
        };

        if (!options) {
            return baseObserverOptions;
        }

        const result = {};

        for (const key in baseObserverOptions) {
            result[key] = baseObserverOptions[key];
        }

        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                result[key] = options[key];
            }
        }

        return result;
    }

    getPostId($el) {
        return Number($el.getAttribute('data-id'));
    }

    fetchNextPost() {
        if (this.isLoading) {
            return;
        }

        const excluded = [
            ...this.ratedPosts,
            ...this.loadedPosts.map(p => p.id)
        ].join(',');
        const apiUrl = Routing.generate('blog.view.infinite.scroll.list', {
            post: this.entityId,
            excluded,
            isCollection: this.isCollection ? 1 : 0
        });

        const customHeaderValue = MNTK.isAcceptWebp
            ? {'Accept': 'text/html,application/xhtml+xml,application/xml,image/webp'}
            : {}
        ;

        this.isLoading = true;
        MNTK.fetchJson(apiUrl, {customHeader: customHeaderValue})
            .then(({ json }) => {
                const { nextRelatedPost, nextPostNotFound } = json;
                if (nextPostNotFound) {
                    this.allPostsLoaded = true;
                    return;
                }

                this.renderPost(nextRelatedPost);
                this.isLoading = false;
            })
            .catch(console.log);
    }

    renderPost(post) {
        if (!post) return;

        const { h1, descriptionHtml, id, title, url } = post;
        this.loadedPosts.push({ id, title, url });

        const isCollection =
            post.collection && post.collection.collectionCostXf;

        const $post = document.createElement('div');
        $post.setAttribute('data-id', id);
        $post.setAttribute('id', `post-${id}`);
        $post.classList.add('post');

        const $headline = document.createElement('h1');
        $headline.classList.add('headline');
        $headline.innerHTML = h1;

        const $card = document.createElement('div');
        $card.classList.add('card', 'card_post', 'card_fullscreen');
        $card.setAttribute('data-h1', h1);
        $card.setAttribute('data-title', title);

        $card.innerHTML = isCollection
            ? `<div class="post-short">${descriptionHtml}</div><span class="show-content">Показать полностью</span>`
            : descriptionHtml;

        $post.appendChild($headline);
        $post.appendChild($card);
        this.$targetEl.appendChild($post);

        // аналитика
        this.sendPostLoadEvent();

        // предметы в коллекции
        if (post.goodsRelationsHtml) {
            if (this.isCollection) {
                $post.innerHTML += post.goodsRelationsHtml;
            } else {
                $card.innerHTML += post.goodsRelationsHtml;
            }

            MNTK.emit('updateLazyLoad');
            MNTK.emit('updateComponents');
        }

        // статус коллекции
        if (isCollection) {
            const loadedPost = this.loadedPosts.find(p => p.id === id);
            if (loadedPost) {
                loadedPost.collection = post.collection;
            }
        }

        this.renderPostRating(id);
        this.createPostObserver(id);
        this.createRatingObserver(id);

        const timeout = setTimeout(function () {
            MNTK.emit('renderNoIndexImages', $post);
            MNTK.emit('updateZoomLoadImages');
            MNTK.emit('updateLazyLoadImages');

            clearTimeout(timeout);
        }, 1);
    }

    renderPostRating(postId) {
        const $rating = document.getElementById(`rating-${this.entityId}`);
        if (!$rating) return;

        const $cloneRating = $rating.cloneNode(true);
        $cloneRating.setAttribute('id', `rating-${postId}`);
        $cloneRating.setAttribute('data-id', postId);
        $cloneRating.setAttribute('data-post-id', postId);
        $cloneRating.querySelector('.rate')?.setAttribute('data-id', postId);

        const $post = document.getElementById(`post-${postId}`);
        $post.appendChild($cloneRating);

        $cloneRating
            .querySelectorAll('button')
            .forEach($btn => $btn.classList.remove('hidden'));
        $cloneRating.querySelector('.rate__cancel').classList.add('hidden');
        const $text = $cloneRating.querySelector('span');
        if ($text) {
            $text.textContent = '';
            $text.classList.add('hidden');
        }

        const $relatedContent = $cloneRating.querySelector(
            '[data-component="ShowRelatedContent"]'
        );
        if ($relatedContent) {
            $relatedContent.style.display = 'none';
        }

        MNTK.emit('updateRating', postId);
    }

    changeLocationUrl(post) {
        const { id, title, url, collection } = post;
        document.title = title;
        history.replaceState(null, title, url);

        if (id === `${this.entityId}`) {
            this.hideAllProgressBars(`${this.entityId}`);
            return;
        }

        if (collection) {
            const $progress = document.querySelector(
                `.collection-progress[data-collection="${id}"]`
            );
            if (!$progress) {
                const $page = document.querySelector('.page');
                const $newProgressBar = this.renderCollectionProgressBar({
                    id,
                    collectionCostXf: post.collection.collectionCostXf,
                    priceNote: post.collection.priceNote,
                    current: Number(post.collection.progress.current),
                    total: Number(post.collection.progress.total)
                });
                $page.parentNode.insertBefore($newProgressBar, $page);
            }

            this.hideAllProgressBars(id);
        }

        this.trackPageView();
    }

    createPostObserver(postId) {
        const options = this.getLazyloadOptions({
            elements_selector: `#post-${postId}`
        });
        const observer = new LazyLoad(options);
        this.postObservers.push(observer);
    }

    createRatingObserver(postId) {
        const options = {
            elements_selector: `#rating-${postId}`,
            threshold: 0,
            callback_enter: () => {
                this.sendPostReadEvent(postId);
            }
        };
        this.ratingsObservers[postId] = {
            observer: new LazyLoad(options),
            eventSent: false
        };
    }

    sendPostLoadEvent() {
        MNTK.stat?.onReady(function () {
            gtag('event', 'Click', {
                'event_category': 'BLOG_ADDITION_POST_LOADED',
                'event_label': 'No',
                'non_interaction': true
            });

            MNTK.stat.trackYm('reachGoal', 'BLOG_ADDITION_POST_LOADED');
        });
    }

    sendPostReadEvent(postId) {
        const postRatingObserver = this.ratingsObservers[postId];
        if (!postRatingObserver) return;

        const { eventSent, observer } = postRatingObserver;
        if (!eventSent) {
            MNTK.stat?.onReady(function () {
                gtag('event', 'Click', {
                    'event_category': 'BLOG_ADDITION_POST_READ',
                    'event_label': 'No',
                    'non_interaction': true
                });

                MNTK.stat.trackYm('reachGoal', 'BLOG_ADDITION_POST_READ');
            });
            postRatingObserver.eventSent = true;
            observer.destroy();
        }
    }

    renderCollectionProgressBar(post) {
        const { id, priceNote, collectionCostXf, current, total } = post;

        const width =
            current === total
                ? 'calc(100% - 4px)'
                : `${(current / total) * 100}%`;
        const div = document.createElement('div');
        div.classList.add('collection-progress');
        div.setAttribute('data-collection', id);
        div.innerHTML = `<div class="container">
            <div class="collection-progress__title">
                <p>
                    Всего собрано монет <span class="text-accent">${current}</span>&nbsp;из&nbsp;${total}
                </p>
                <div class="collection-progress__bar">
                    <div class="fill ${current === total ? 'completed' : ''}"
                         data-count="${current}"
                         data-max="${total}"
                         style="width: ${width};"
                    ></div>
                </div>
            </div>
            <div class="collection__price">
                <span class="price">~&nbsp;${collectionCostXf.toLocaleString(
                    'ru'
                )}&nbsp;&#8381;</span>
                <span>${priceNote}</span>
            </div>
        </div>`;
        return div;
    }

    hideAllProgressBars(id) {
        document
            .querySelectorAll('.collection-progress')
            .forEach($el =>
                $el.classList.toggle(
                    'd-none',
                    $el.getAttribute('data-collection') !== id
                )
            );
    }

    trackPageView() {
        MNTK.stat?.onReady(() => {
            gtag('event', 'page_view', {
                page_title: document.title,
                page_path: location.pathname
            });

            MNTK.stat.trackYm('reachGoal', 'PageView');
        });
    }
}
